<template>

    <section class="section section_album pt-2 pb-2"> 
        <div class="container">   	
            <div class="owl_album">
                <carousel 
                    :autoplay="true"
                    :margin="0"
                    :nav="false"
                    :dots="false" 
                    :responsive="{
                        0:{items:1},
                        768:{items:1},
                        992:{items:1}
                    }" 
                    
                    class="owl-theme">
                    <div class="item">
                        
                            <div class=" al-item relative">
                                <img src="/img/slider/slide-1.jpg" data-lazyload="#" alt="">
                                
                            </div>	
                        
                    </div>                
                    <div class="item">
                        
                            <div class=" al-item relative">
                                <img src="/img/slider/slide-2.jpg" data-lazyload="#" alt="">
                                
                            </div>	
                        
                    </div>                               
                </carousel>                            
            </div>
        </div>                   	
    </section> 
</template>
<script>
import carousel from 'vue-owl-carousel';
export default {
  name: "RwSlider-home",
  components: {
    carousel
  }
};
</script>
